import { Flex, Typography } from "@aircall/tractor";

import { EvaluationComment } from "../EvaluationComment";
import { EvaluationQuestionSummaryRating } from "../EvaluationQuestionSummaryRating";

import { EvaluationQuestionSummaryProps } from ".";

export function EvaluationQuestionSummary<Rating extends string>({
  rank,
  question,
  value,
  maximumPoints,
  points,
  answerGuide,
  isNotApplicable = false,
  comment,
  ...wrapperFlexProps
}: EvaluationQuestionSummaryProps<Rating>) {
  return (
    <Flex flexDirection="column" gap="xxs" {...wrapperFlexProps}>
      <Flex alignItems="center" gap="m">
        <Flex flex={3} gap="xxs">
          <Typography variant="bodySemiboldM">{`${rank}.`}</Typography>
          <Flex flexDirection="column" gap="xxxs">
            <Typography variant="bodySemiboldM">{question}</Typography>
            <Typography variant="supportingRegularS">{answerGuide}</Typography>
          </Flex>
        </Flex>
        <EvaluationQuestionSummaryRating
          value={value}
          maximumPoints={maximumPoints}
          points={points}
          disabled={isNotApplicable}
        />
      </Flex>
      {comment && <EvaluationComment>{comment}</EvaluationComment>}
    </Flex>
  );
}
